import React, { useState } from "react";
import { Modal } from "antd";
import "../modal.scss";
import "./index.scss";
import LoginContent from "@/components/Login/Content";
// import Type from './Type';
export interface ILoginModalProps {
  hiddenModal: () => void;
  submitAction?: () => void;
}

const LoginModal: React.FC<ILoginModalProps> = ({
  hiddenModal,
  submitAction,
}) => {
  const [open, setOpen] = useState(true);
  const callback4Login = () => {
    setOpen(false);
    submitAction();
  };

  return (
    <Modal
      open={open}
      wrapClassName="modal-wrapper login-modal-wrapper"
      onCancel={hiddenModal}
      footer={null}
      width="46.667rem"
      title={<div></div>}
      centered
    >
      <LoginContent type="modal" submitAction={callback4Login} />
    </Modal>
  );
};

export default LoginModal;
